export default __webpack_public_path__ + "static/media/agustin.b4ccbfa4.jpeg";